import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VariablesProvidingPopup from '../popups/VariablesProvidingPopup';
import { joinClassNames } from '../../utils';

VariablesProvidingButton.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    variablesProvidingComp: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    tabIndex: PropTypes.number,
    showPopupOnLoad: PropTypes.bool,
};

VariablesProvidingButton.defaultProps = {
    className: '',
    disabled: false,
    title: null,
    tabIndex: null,
    showPopupOnLoad: false,
};

function VariablesProvidingButton(props) {
    const {
        className,
        children,
        onConfirm,
        onCancel,
        variablesProvidingComp,
        disabled,
        title,
        tabIndex,
        showPopupOnLoad,
    } = props;
    const [isPopupVisible, setPopupVisible] = useState(showPopupOnLoad);
    const onClickHandler = () => setPopupVisible(true);
    const onCancelHandler = () => {
        setPopupVisible(false);
        onCancel();
    };
    const onConfirmCompleted = (variables) => {
        setPopupVisible(false);
        onConfirm(variables);
    };
    return (
        <>
            <button
                type="button"
                className={joinClassNames('variables-providing-button', className)}
                onClick={onClickHandler}
                disabled={disabled}
                title={title}
                aria-label={title}
                tabIndex={tabIndex}
            >
                {children}
            </button>
            {isPopupVisible && (
                <VariablesProvidingPopup
                    onConfirm={onConfirmCompleted}
                    onCancel={onCancelHandler}
                    variablesProvidingComp={variablesProvidingComp}
                />
            )}
        </>
    );
}

export default VariablesProvidingButton;
